// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"123":"4bed178e","187":"66c6cba0","489":"5a18a99f","753":"76c10221"}[chunkId] + ".js";
};